import React, { useEffect, useState } from "react";
import SplineAreaChart from "../../../../CHARTS/SplineChart";

import {
  formatDateToDis,
  getCurrentDate,
  getOnePreviousDate,
} from "../../../../Utilitie";
import Loading from "../../../../Extra/Loading";

const Report02Graph = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [dates, setDates] = useState([]);

  // Only allowed groups
  const allowedGroups = ["totalM", "MPSO"];

  useEffect(() => {
    if (!data?.length) return;

    // Filter only allowed groups (totalM, totalP)
    const filtered = data.filter((d) => allowedGroups.includes(d.group_type));

    // Sort by earliest → latest
    const sorted = filtered.sort(
      (a, b) => new Date(a.report_date) - new Date(b.report_date),
    );

    // Unique dates list
    const uniqueDates = [
      ...new Set(
        sorted.map((item) =>
          new Date(item.report_date)
            .toLocaleDateString("en-GB", {
              timeZone: "Asia/Kolkata",
            })
            .slice(0, 5),
        ),
      ),
    ];
    setDates(uniqueDates);

    // Build chart data only for PP_CFY_DAY
    const chart = allowedGroups.map((g) => ({
      name: `${g} PP_CFY_DAY`,
      data: sorted
        .filter((item) => item.group_type === g)
        .map((item) => Number(item.PP_CFY_DAY || 0)),
    }));

    setChartData(chart);
  }, [data]);

  return (
    <div className="">
      <h6 className="text-white bg-dark p-2">Punctuality Graph (PP CFY DAY)</h6>

      {!data ? (
        <Loading />
      ) : (
        <div className="">
          <div>
            <span className="badge bg-primary me-2">MEXP PP CFY DAY</span>
            <span className="badge " style={{ backgroundColor: "#62e05dff" }}>
              PASS PP CFY DAY
            </span>
          </div>
          <div
            className="mt-3"
            style={{ background: "rgba(255, 255, 255, 0.21)" }}
          >
            {" "}
            {chartData && dates.length ? (
              <SplineAreaChart
                data={chartData}
                categories={dates}
                from="Punctuality"
              />
            ) : (
              <div className="text-center p-2">No Chart Data</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Report02Graph;
